import { Component, Input,OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'dropdown-question',
  template:`<div [formGroup]="form">
      <kendo-formfield>
          <!-- <kendo-label [for]="question.key" [text]="question.label"></kendo-label> -->
          <kendo-floatinglabel  [text]="question.label">
          <kendo-combobox [id]="question.key"
                            [formControlName]="question.key"
                            [clearButton]="true" 
                            [data]="question.options"
                            [valueField]="'key'"
                            [textField]="'value'"
                            [disabled]="!question.options.length || (!isEmpty(question.value) && question.disabled)">
                            <!-- [disabled]="isDisabled$ |async"> -->
        </kendo-combobox>
        </kendo-floatinglabel>
        <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.maxlength">Error: {{errorMax.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.minlength">Error: {{errorMin.value}}</kendo-formerror>
          <!-- <kendo-formerror>Error: {{question.label}} is required</kendo-formerror> -->
      </kendo-formfield>
</div>`
})
export class DropDownFormQuestionComponent implements OnChanges {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;


  errorRequired: { key: string; value: string; };
  errorMax: { key: string; value: string; };
  errorMin: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) {
    // console.log('ngOnChangesDropdown',changes,this.question)
    // console.log('isEmpty',!this.isEmpty(this.question.value), this.question.disabled,this.question,(!this.isEmpty(this.question.value)&& this.question.disabled))

    // if(changes.question.firstChange){ 
    //   this.errorRequired = changes.question.currentValue.errors.find( ({ key }) => key === 'required' )
    //   this.errorMax = changes.question.currentValue.errors.find( ({ key }) => key === 'maxLength' )
    //   this.errorMin = changes.question.currentValue.errors.find( ({ key }) => key === 'minLength' )
    // }
  
      this.errorRequired = this.question.errors.find( ({ key }) => key === 'required' )
      this.errorMax = this.question.errors.find( ({ key }) => key === 'maxLength' )
      this.errorMin = this.question.errors.find( ({ key }) => key === 'minLength' )
    
  }

   isEmpty(obj) {
    //  console.log('this.question,obj',this.question,obj)
     if(!obj){
    return true
     }
    for(var prop in obj) {
      if(Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
  
    return JSON.stringify(obj) === JSON.stringify({});
  }

}